import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        backgroundColor: "#eee",
    },
}));

const TicketTags = ({ ticket }) => {
    const classes = useStyles();
    const [ticketTags, setTicketTags] = useState([]);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (ticket && ticket.contact) {
            setTicketTags(ticket.contact.tags || []);
        }
    }, [ticket]);

    useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }

        (async () => {
            try {
                const { data } = await api.get("/tags/list");
                if (active) {
                    setOptions(data);
                }
            } catch (err) {
                toastError(err);
            }
        })();

        return () => {
            active = false;
        };
    }, [loading]);

    const handleChange = async (event, newValue) => {
        const selectedTags = [];
        for (const item of newValue) {
            if (typeof item === 'string') {
                try {
                    const { data } = await api.post("/tags", { name: item, color: '#1b0de3' });
                    selectedTags.push(data);
                } catch (err) {
                    toastError(err);
                }
            } else {
                selectedTags.push(item);
            }
        }

        const contactId = ticket.contact.id;
        const tags = selectedTags.map((t) => t.id);

        try {
            await api.put(`/contacts/${contactId}`, { tags });

            if (selectedTags.length < ticketTags.length) {
                toast.warn(i18n.t("tags.toasts.deleted"));
            } else {
                toast.success(i18n.t("tags.toasts.success"));
            }

            setTicketTags(selectedTags);
        } catch (err) {
            toastError(err);
        }
    };

    if (!ticket || !ticket.contact) return null;

    return (
        <Paper square className={classes.root}>
            <Autocomplete
                multiple
                id="tags-outlined"
                freeSolo
                options={options}
                getOptionLabel={(option) => {
                    if (typeof option === "string") {
                        return option;
                    }
                    if (option.inputValue) {
                        return option.inputValue;
                    }
                    return option.name;
                }}
                getOptionSelected={(option, value) => {
                    if (typeof value === "string") {
                        return option.name === value;
                    }
                    return option.id === value.id
                }}
                value={ticketTags}
                onChange={handleChange}
                onOpen={() => {
                    setLoading(true);
                }}
                onClose={() => {
                    setLoading(false);
                }}
                loading={loading}
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => (
                        <Chip
                            label={option.name}
                            {...getTagProps({ index })}
                            style={{ backgroundColor: option.color || "#eee", color: "#fff" }}
                            size="small"
                        />
                    ))
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label={i18n.t("tags.title")}
                        placeholder={i18n.t("tags.buttons.add")}
                    />
                )}
            />
        </Paper>
    );
};

export default TicketTags;
